// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const AttackFilledIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="AttackFilledIcon" ref={forwardedRef} {...props}>
      <path d="M17 17H2.75v-2.76a2.75 2.75 0 0 1 .752-1.873c.484-.517 1.67-.857 2.395-.942L3.722 9.181a1.6 1.6 0 0 1 0-1.61L8.347 2.88A3.3 3.3 0 0 1 9.88 2.5a3.3 3.3 0 0 1 1.532.38l4.616 4.691a1.4 1.4 0 0 1 .255.805 1.4 1.4 0 0 1-.255.805l-1.53 2.244c.715.095 1.295.44 1.769.955A2.74 2.74 0 0 1 17 14.24zM7.637 6.626 7.64 9.051a2.6 2.6 0 0 0 .152.903 2.4 2.4 0 0 0 .456.77 2.1 2.1 0 0 0 .69.518 2 2 0 0 0 .817.185h.904a2.07 2.07 0 0 0 1.523-.698 2.5 2.5 0 0 0 .634-1.678V6.626a15.8 15.8 0 0 0-5.178 0" />
    </SvgIcon>
  );
});

/**
 * Usage only for within charts
 * @public
 */
export const AttackFilledIcon = /* @__PURE__ */ Object.assign(
  AttackFilledIconComponent,
  { displayName: 'AttackFilledIcon' },
);
